import type { JSX } from "react";
import { Button, DialogActions, DialogTitle } from "@mui/material";
import { bound } from "ecce-react";
import { Prompt } from "../../prompt/prompt";


export class ConfirmDiscardUnsavedChangesPrompt extends Prompt<boolean> {
	override view = (): JSX.Element => <ConfirmDiscardUnsavedChangesPromptView prompt={ this }/>;

	@bound()
	discard(): void {
		this.submit(true);
	}

	@bound()
	continueEditing(): void {
		this.submit(false);
	}
}

const ConfirmDiscardUnsavedChangesPromptView = (p: { prompt: ConfirmDiscardUnsavedChangesPrompt; }) => {
	return (
		<>
			<DialogTitle>
				Your changes have not been saved.
			</DialogTitle>
			<DialogActions>
				<Button variant="text" color="error" onClick={ p.prompt.discard }>
					Discard changes
				</Button>
				<Button variant="text" color="primary" onClick={ p.prompt.continueEditing }>
					Continue editing
				</Button>
			</DialogActions>
		</>
	);
};
